import { useSelector } from "react-redux";
import { Fragment, useEffect, useState } from "react";
import { Grid, Checkbox, Typography } from "@mui/material";

import { useAxios } from "../../../../hooks";
import { AutocompleteMultiSelect, TextField } from "../../../../components";

export default function AudienceName({
  state,
  dispatch,
  editState,
  formikProps,
  setFields,
}) {
  const axios = useAxios();
  const [input, setInput] = useState({});
  const [message, setMessage] = useState({});
  const [contributors, setContributors] = useState([]);

  const { parentState } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    if (state["audience_group"]) {
      setInput((prev) => ({
        ...prev,
        audience_group: state["audience_group"],
      }));
    }

    if (state["contributorsChecked"]) {
      setInput((prev) => ({
        ...prev,
        contributorsChecked: state["contributorsChecked"],
      }));
    }
  }, [state]);

  useEffect(() => {
    if (formikProps?.values?.contributorsChecked) {
      axios({
        url: "/user/getAllDataPartner",
        method: "get",
        disableRedirect: true,
        disableError: true,
      }).then((response) => {
        let contributors = [];
        if (response.status) {
          for (let contributor of response.data.data) {
            if (contributor.connectionDetails.status === "ACTIVE") {
              contributors.push({
                id: contributor.connectionDetails.brand_id,
                name: contributor.brandDetails.brand_name,
              });
            }
          }
          setContributors(contributors);
        }
      });
    }
  }, [formikProps.values.contributorsChecked, axios]);

  useEffect(() => {
    if (formikProps.values?.contributors?.value?.length > 0) {
      axios({
        url:
          "/adtech/getAllDynamicFields?contributor_id=" +
          formikProps.values.contributors.value,
        method: "GET",
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setFields(response.data);
        }
      });
    }
  }, [axios]);

  const handleFieldChange = (value, name, key) => {
    dispatch({
      type: "UPDATE_FIELD",
      formikProps: formikProps,
      payload: { value, name, key },
    });
  };

  const handleCheckboxChange = (e) => {
    setInput((prev) => ({
      ...prev,
      contributorsChecked: e.target.checked,
    }));
    dispatch({
      type: "CHECKBOX",
      payload: {
        name: "contributorsChecked",
        value: e.target.checked,
      },
    });
  };

  return (
    <Fragment>
      <Grid size={6}>
        <TextField
          required
          size="small"
          label="Audience Group Name"
          name="audience_group.value"
          placeholder="Audience Group Name"
          disabled={!editState}
          value={input?.audience_group?.value}
          onBlur={(e) => {
            if (input.audience_group?.value) {
              handleFieldChange(
                input.audience_group.value,
                "audience_group",
                "value"
              );
            }
          }}
          onChange={(e) => {
            if (e.target.value?.length < 3) {
              setMessage({
                audience_group: "Audience Group must be at least 3 characters",
              });
            } else {
              setMessage({});
            }
            setInput({ audience_group: { value: e.target.value } });
          }}
          error={message["audience_group"]}
          helperText={message["audience_group"]}
        />
      </Grid>

      {parentState === "SA" && (
        <Fragment>
          <Grid size={6} style={{ display: "flex", alignSelf: "center" }}>
            <Typography style={{ display: "flex", alignSelf: "center" }}>
              Selective Contributors
            </Typography>
            <Checkbox
              checked={
                input.contributorsChecked ||
                formikProps.values.contributorsChecked
              }
              disabled={!editState}
              onChange={handleCheckboxChange}
              inputProps={{ "aria-label": "controlled" }}
              sx={{
                color: "rgb(143, 28, 130)",
                "&.Mui-checked": {
                  color: "rgb(143, 28, 130)",
                },
              }}
            />
          </Grid>

          {formikProps.values.contributorsChecked && (
            <Grid size={6}>
              <AutocompleteMultiSelect
                size="small"
                forcePopupIcon={!editState ? false : true}
                label={"Select Contributors"}
                name={`contributors.value`}
                state={state}
                formikProps={formikProps}
                disabled={!editState}
                defaults={{
                  primaryKey: "id",
                  displayLabel: "name",
                }}
                options={contributors}
                placeholder={"Select Contributors"}
                onChange={(_, arr, reason, detail) =>
                  handleChange(arr, detail, reason, `contributors.value`, "id")
                }
                onBlur={() => {
                  handleDropDown(
                    input.contributors.value,
                    "contributors",
                    "value"
                  );
                }}
              />
            </Grid>
          )}
        </Fragment>
      )}
    </Fragment>
  );

  function handleDropDown(value, name, key) {
    dispatch({
      type: "MULTI_DROP_DOWN",
      payload: { value, name, key },
    });
  }

  function handleChange(arr, { option }, reason, name, displayName, options) {
    let objectName = name.substring(0, name.indexOf("."));

    setInput((prev) => ({
      ...prev,
      [objectName]: setValuesOfDropDown(input[objectName]?.value),
    }));

    function setValuesOfDropDown(val) {
      let values = val ? [...val] : [];

      if (reason === "removeOption") {
        let v = option.id;
        if (values.includes(v)) {
          values = [...values.filter((items) => items !== option.idcon)];
        } else {
          values.pop();
        }
      }
      if (reason === "selectOption") {
        values.push(option[displayName]);
      }

      handleDropDown(values, "contributors", "value");
      axios({
        url: "/adtech/getAllDynamicFields?contributor_id=" + values?.join(","),
        method: "GET",
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setFields(response.data);
        }
      });

      val = {
        value: values,
      };

      return val;
    }
  }
}
